import awsconfig from "../amplify_outputs.json";

export const info_data = {
  contactMail: "contact@blings.io",
  support: "support@blings.io",
};

export const getENV = (): "dev" | "staging" | "master" => {
  // Gen2 has no REST endpoint path to read the env from. Post-refactor the
  // storage bucket carries it (platform-storage-bucket-master); pre-refactor it
  // is CDK-auto-named, so also check the REST API keys, which always carry the
  // deploy branch ("BlingsAPI-gen2-master").
  const restApiKeys = Object.keys((awsconfig as any).custom?.API ?? {});
  if (
    awsconfig.storage.bucket_name.includes("master") ||
    restApiKeys.some((k) => k.endsWith("-gen2-master"))
  )
    return "master";
  if (awsconfig.storage.bucket_name.includes("staging")) return "staging";
  return "dev";
};

export const CDN = {
  dev: "https://dh2jw0564x0cd.cloudfront.net",
  staging: "https://d25az89v0z0rdg.cloudfront.net",
  master: "https://storage.blings.io",
};
export const BLINGS_API = {
  dev: "https://n5i659t7zj.execute-api.eu-west-1.amazonaws.com/dev/v2/public",
  staging: "https://o1d26b9xt3.execute-api.eu-west-1.amazonaws.com/staging",
  master: "https://api.blings.io/v2/public",
};
export const GET_PLAYER_SETTINGS_URL = {
  dev:
    "https://n5i659t7zj.execute-api.eu-west-1.amazonaws.com/dev/v2/public/project",
  master: "https://api.blings.io/v2/public/project",
  staging:
    "https://csjxoutuob.execute-api.eu-west-1.amazonaws.com/staging/projects",
}[getENV()];
export const DEFAULT_MAX_LAYER_CHARS = 20;

export const HELP_CENTER_URL = "https://help.blings.io/enterprise";

export const MICROSERVICE_API_URLS = {
  font: {
    dev:
      "https://5ptkfkesj2.execute-api.eu-west-1.amazonaws.com/dev/v1/public/convert/font",
    master:
      "https://2bzp4hwfqj.execute-api.eu-west-1.amazonaws.com/master/v1/public/convert/font",
  }[getENV()] as string,
  image: {
    dev:
      "https://tee1st7f3d.execute-api.eu-west-1.amazonaws.com/dev/v1/private/convert/image",
    master:
      "https://xtt82dfuj8.execute-api.eu-west-1.amazonaws.com/master/v1/private/convert/image",
  }[getENV()] as string,
};

export const TABS = {
  LAYERS: "layers",
  FLOW: "flow",
  THUMB: "thumb",
};

export const tabsOptions: {
  title: string;
  value: string;
  icon: string;
  path: string;
}[] = [
  {
    title: "Layer Modifier",
    value: TABS.LAYERS,
    icon: "LayersIcon",
    path: "layers",
  },
  { title: "Flow builder", value: TABS.FLOW, icon: "FlowIcon", path: "flow" },
  // {
  //   title: "Thumb editor",
  //   value: TABS.THUMB,
  //   icon: "ImageIcon",
  //   path: "thumb",
  // },
];
